var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"tag":"div","rules":_vm.rules,"vid":_vm.vid},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_vm._t("default",null,{"error":errors[0]}),(!_vm.customValidation && errors[0])?_c('FieldValidationError',{attrs:{"is-static":_vm.isStaticError}},[_vm._v(" "+_vm._s(errors[0])+" ")]):_vm._e()]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }